import { ActionTypes as DataActionTypes, } from '../../actions/data';
import { getCategoryPath } from '../../utils/routes';
export const initialState = {};
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case DataActionTypes.CATEGORY_TREE_HYDRATE:
        case DataActionTypes.CATEGORY_TREE_REQUEST_SUCCESS: {
            const stateAccumulator = { ...state };
            reduceCategories({
                accumulator: stateAccumulator,
                categories: action.payload.data.categories,
                languageId: action.payload.languageId,
                parentCategory: null,
            });
            return stateAccumulator;
        }
        case DataActionTypes.ARTICLE_PAGE_DATA_HYDRATE:
        case DataActionTypes.ARTICLE_PAGE_DATA_REQUEST_SUCCESS:
            return articlePageResults(state, action.payload);
        case DataActionTypes.CATEGORY_PAGE_DATA_HYDRATE:
        case DataActionTypes.CATEGORY_PAGE_DATA_REQUEST_SUCCESS:
            return categoryPageResults(state, action.payload);
    }
    return state;
};
export default reducer;
function categoryPageResults(state, payload) {
    var _a;
    const category = payload.data.category;
    if (!category)
        return state;
    const languageId = payload.languageId;
    const stateAccumulator = { ...state };
    stateAccumulator[category.id] = filloutCategory(category, ((_a = category.parentCategory) === null || _a === void 0 ? void 0 : _a.id) || null, languageId);
    reduceCategories({
        categories: category.subCategories,
        accumulator: stateAccumulator,
        languageId,
        parentCategory: category.id,
    });
    // parentCategory
    if (category.parentCategory &&
        !stateAccumulator[category.parentCategory.id]) {
        stateAccumulator[category.parentCategory.id] = filloutCategory(category.parentCategory, null, languageId);
    }
    return stateAccumulator;
}
function articlePageResults(state, payload) {
    var _a, _b;
    const { data, languageId } = payload;
    const category = (_a = data.article) === null || _a === void 0 ? void 0 : _a.category;
    if (!category)
        return state;
    const stateAccumulator = { ...state };
    // category
    stateAccumulator[category.id] = filloutCategory(category, ((_b = category.parentCategory) === null || _b === void 0 ? void 0 : _b.id) || null, languageId);
    // subCategories
    reduceCategories({
        categories: category.subCategories,
        accumulator: stateAccumulator,
        languageId,
        parentCategory: category.id,
    });
    // parentCategory
    if (category.parentCategory &&
        !stateAccumulator[category.parentCategory.id]) {
        stateAccumulator[category.parentCategory.id] = filloutCategory(category.parentCategory, null, languageId);
    }
    return stateAccumulator;
}
// NOTE: accumulator is mutated!
function reduceCategories({ categories, accumulator, parentCategory, languageId, }) {
    categories.reduce((acc, c) => {
        //  only if this stuff doesnt' exist
        const cat = filloutCategory(c, parentCategory, languageId);
        accumulator[cat.id] = cat;
        if (c.subCategories) {
            reduceCategories({
                categories: c.subCategories,
                accumulator: acc,
                parentCategory: c.id,
                languageId,
            });
        }
        return acc;
    }, accumulator);
}
function filloutCategory(c, parentCategory, languageId) {
    var _a, _b;
    return {
        ...c,
        parentCategory,
        path: getCategoryPath({ languageId, slug: c.slug }),
        subCategories: ((_a = c.subCategories) === null || _a === void 0 ? void 0 : _a.map((sub) => sub.id)) || [],
        articles: ((_b = c.articles) === null || _b === void 0 ? void 0 : _b.results.map((a) => a.id)) || [],
    };
}
//# sourceMappingURL=categoryCache.js.map